import React, { useEffect, useState, useCallback } from 'react'
import StringUtil from 'utils/string-util'
import MerchantContractsApiV2 from 'api/v2/admins/merchant-contracts-api-v2'
import { InputField } from 'components'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag    : PropTypes.any,
  fieldName    : PropTypes.string,
  merchantType : PropTypes.string
}

const defaultValues = {
  formikBag    : null,
  fieldName    : '',
  merchantType : ''
}

/**
 * Contract options for dropdown input field. hooked up to Formik (only to be used within a Formik component)
 * @param {any} formikBag an object containing a subset of the injected props and methods and any props that were passed to the wrapped component.
 * @param {string} fieldName name for fieldName input-field
 */
const MerchantContractField = ({
  formikBag,
  fieldName,
  merchantType
}) => {
  const [ contracts, setContracts ]   = useState([])
  const [ totalCount, setTotalCount ] = useState(1)

  const getContracts = useCallback(() => {
    const additionalFilters = {
      per_page      : totalCount,
      merchant_type : merchantType
    }

    MerchantContractsApiV2.get({
      additionalFilters: additionalFilters
    })
      .then((response) => {
        setContracts(response.data.merchant_contracts)
        setTotalCount(response.data.meta.total_count)
      })
      .catch(() => {
        alert('Cannot fetch Merchant Contracts')
      })
  },[ merchantType, totalCount ])

  // get Contracts data
  useEffect(() => {
    if (merchantType) {
      getContracts()
    }

    if (merchantType && totalCount) {
      getContracts()
    }
  }, [ getContracts, merchantType, totalCount ])

  // components to show
  const SelectFieldOptions = () => (
    <>
      <option value={ '' } label={ 'Choose Contract' }/>
      {
        contracts.map((option) => (
          <option
            key={ `select-option-contract-${option.id}` }
            value={ option.id }
            label={ StringUtil.titleCase(option.name) }
          />
        ))
      }
    </>
  )

  return (
    <InputField
      type='select'
      name={ fieldName }
      label='Contract'
      required={ true }
      onChange={ (e) => formikBag.handleChange(e) }
    >
      <SelectFieldOptions />
    </InputField>
  )
}

MerchantContractField.propTypes    = propTypes
MerchantContractField.defaultProps = defaultValues

export default MerchantContractField